export default __webpack_public_path__ + "static/media/budgetsdates.76d3daf5.svg";